var exports = {
  "k": "x112a1f60--1bdab6--container",
};

module.exports = exports;
